import apiClient from '../authentication/utils/core/axios';

/**
 * StatusMapAPI — admin-only CRUD for the live Architecture Status Map, the
 * in-app twin of the standalone HTML report generated during the security-
 * hardening pass. Same "integral, always-current view" intent as RoadmapAPI.
 */
const StatusMapAPI = {
  fetchItems: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.status) query.append('status', params.status);
    if (params.severity) query.append('severity', params.severity);
    if (params.component) query.append('component', params.component);
    const res = await apiClient.get(`/admin/status-map/?${query.toString()}`);
    return res.data;
  },

  fetchComponents: async () => {
    const res = await apiClient.get('/admin/status-map/components');
    return res.data;
  },

  createItem: async (itemData) => {
    const res = await apiClient.post('/admin/status-map/', itemData);
    return res.data;
  },

  updateItem: async (itemId, updates) => {
    const res = await apiClient.patch(`/admin/status-map/${itemId}`, updates);
    return res.data;
  },

  deleteItem: async (itemId) => {
    await apiClient.delete(`/admin/status-map/${itemId}`);
    return itemId;
  },
};

export default StatusMapAPI;
